import { memo } from "react";
import OtpInput from "../landing_comp/otpInput";
import PinInput from "../landing_comp/pinInput";
import type { FormError } from "../../types/home";
import seekhologo from "../../Assets/Images/seekhologo.webp";
import world from "../../Assets/Images/World.png";
import mobile from "../../Assets/Images/Mobile.webp";
import app_store from "../../Assets/Images/Appstore icon.png";

export interface SubscribeSectionProps {
  token: string | null;
  utmSource: string;
  otpStatus: boolean;
  loader: boolean;
  error: FormError;
  webOtp: string | null;
  phNumber: string;
  onSubscribe: (phone: string) => void;
  onVerifyOtp: (otp: string) => void;
  setUserPackage: (value: string) => void;
  setLoader: (value: boolean) => void;
  setIsActive: (value: boolean) => void;
}

const SubscribeSection = ({
  token,
  utmSource,
  otpStatus,
  loader,
  error,
  webOtp,
  phNumber,
  onSubscribe,
  onVerifyOtp,
  setUserPackage,
  setLoader,
  setIsActive,
}: SubscribeSectionProps) => (
  <div className="w-100 my-5 px-2 pt-5">
    <div className="container-xxl p-0 pb-5 position-relative subs_bg">
      <div className="world d-none d-lg-block">
        <img src={world} alt="World" />
      </div>
      <div className="row mx-0">
        <div className="col-12 col-lg-6">
          <div className="w-100 d-block overflow-hidden text-sm-center text-start ms-0 mt-5 pt-4 d-lg-none">
            <h3 className="fw-bold mx-0">Subscribe Now</h3>
            <h3 className="fw-bold mx-0 text-red">Sekho</h3>
            <p className="fw-normal mx-0">
              Have executive, vocational
              <br /> Language and more courses.
            </p>
          </div>
          <div className="w-100 text-center text-lg-end me-3 pe-0 pe-lg-5 position-relative">
            <img
              src={mobile}
              alt="Mobile"
              className="mh-500px landing_mobile me-lg-5 me-0 pe-0 pe-lg-5"
            />
          </div>
        </div>
        <div className="col-12 d-flex flex-column justify-content-center col-lg-6">
          <div className="w-100 text-center text-lg-start">
            <div className="w-100 d-none d-lg-block">
              <h3 className="fw-bold">Subscribe Now</h3>
              <h3 className="fw-bold">
                <img src={seekhologo} alt="logo" width={250} />
              </h3>
              <p className="fw-bold">
                And Get Unlimited Access to 2000+ Video Lectures & Much More.
              </p>
            </div>
            <div className="col-12 col-sm-10 col-md-8 col-lg-10 mx-auto mx-lg-0 mt-4 mt-lg-0 align-items-center">
              <OtpInput
                otpSent={otpStatus}
                submit={false}
                _subscribe={onSubscribe}
                setUserPackage={setUserPackage}
                msisdn={null}
                loader={loader}
                _setLoader={setLoader}
                isHttp={false}
                utm_source={utmSource}
                token={token}
                setIsActive={setIsActive}
              />
            </div>
            <div className="col-12 col-sm-10 col-md-8 col-lg-10 mx-auto mx-lg-0 mt-4 mt-lg-0 align-items-center">
              <PinInput
                otpSent={otpStatus}
                otp={webOtp}
                seconds={null}
                phNumber={phNumber}
                _verifyOtp={onVerifyOtp}
                _subscribe={onSubscribe}
                fromHome
                error={error}
                utm_source={utmSource}
              />
            </div>
            {otpStatus ? null : (
              <div className="w-100 mt-3">
                <small className="fw-light small">
                  <span className="text-red">*</span> Prepaid charges: 7.17
                  incl. tax /day
                </small>
              </div>
            )}
            {/* <div className="w-100 mt-3">
              <a
                href="https://bit.ly/JazzParho"
                target="_blank"
                rel="noreferrer"
                className="playStore_button"
              >
                <img src={app_store} alt="logo" className="mt-1" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default memo(SubscribeSection);
